<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
.icon {
  width: 1em; height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
*{
  padding: 0;
  margin: 0;

}
/* 对于 WebKit 浏览器 */
::-webkit-scrollbar {
    width: 8px; /* 定义滚动条宽度 */
    border-radius: 8px;
}

::-webkit-scrollbar-track {
    background: #f6f6f6; /* 定义滚动条轨道颜色 */
     border-radius: 8px;
}

::-webkit-scrollbar-thumb {
    background: #999; /* 定义滚动条滑块颜色 */
     border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
    background: #999; /* 滑块悬停时的颜色 */
     border-radius: 8px;
}

/* 公用的样式 */
.title-home-main {
  float: left;
  width: 100%;
  text-align: center;
  padding: 60px 0;
  background: #f6f6f6;
}
.title-home-box {
  float: left;
  width: 100%;
  text-align: center;
}
.title-home-one {
  font-size: 34px;
  color: #333;
}

.title-home-two {
  font-size:24px;
  color: #333;
  margin: 20px 0;
}
.icon-hengtiao {
  font-size: 12px;
  zoom: 0.5;
  color: #ca391b;
}

.footer-main{
  float: left;
  width: 100%;
  line-height: 14px;
  text-align: center;
  color: #fff;
  background: #333;
  font-size: 12px;
  padding: 20px;
  box-sizing: border-box;
}

.serviceprovider-main-two {
  float: left;
  width: 80%;
  margin: 0 10%;
  padding: 30px 0;
  background: #fff;
  border-radius: 5px;
  position: relative;

}
.serviceprovider-main-box {
  float: left;
  width: 100%;
}
.serviceprovider-box {
  float: left;
  width: 25%;
}
.solution-box-two{
   width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.solution-box-three{
  width: 28%;
  margin: 10px 1%;
}
.title-top{
  float: left;
  width: 100%;
  background: #CA391B;
  padding: 10px;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
 border-radius: 5px 5px 0 0;
}
.title-bottom{
   float: left;
  width: 100%;
  background: #f0e4e4;
  padding: 20px;
  box-sizing: border-box;
  color: #666;
  min-height: 120px;
  text-align: left;
 border-radius: 0 0 5px 5px;
}
.solution-main {
  width: 100%;
  background: #f6f6f6;
  box-sizing: border-box;
  padding: 20px;
}

.solution-box {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.solution-title-one {
  font-size: 18px;
  color: #666;
  text-align: center;
}

.img-box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.img-li {
  max-width: 100%;
  height: auto;
}
.solution-box-four {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* 项目之间的间隔 */
}

.item-one {
  flex: 1 1 calc(33.333% - 20px); /* 在PC端一行显示3个项目 */
  box-sizing: border-box;
  text-align: center;
   padding: 30px;
   box-sizing: border-box;
}

.item-one-img {
  width: 100px;
  height: auto;
  padding: 20px 0;
}

.item-two {
  flex: 1 1 calc(25% - 20px); /* 在PC端一行显示3个项目 */
  box-sizing: border-box;
  text-align: center;
   padding: 30px;
   box-sizing: border-box;
}
.item-two-img{
  float: left;
  width: 100%;
  margin-bottom: 20px;
}

.item-three {
  flex: 1 1 calc(50% - 20px); /* 在PC端一行显示3个项目 */
  box-sizing: border-box;
  text-align: center;
   padding: 30px;
   box-sizing: border-box;
}
.item-three-img{
  float: left;
  width: 100%;
}

.item-four {
  flex: 1 1 calc(20% - 20px); /* 在PC端一行显示3个项目 */
  box-sizing: border-box;
  text-align: center;
   padding: 10px;
   box-sizing: border-box;
}
.item-four-img{
  float: left;
  width: 100%;
}

.img-li-two{
   max-width: 60%;
  height: auto;
}

.productsdectitle{
    position: relative;
  top: 0px;
  left: 0px;
  font-size:20px;
  color: #000;
}
.title-home-main-three{
   width: 100%;
  background: #f6f6f6;
}
.news-box{
  float: left;
  width: 100%;
  text-indent: 2em;
  font-size: 18px;
  color: #666;
  margin-bottom: 20px;
}

.news-box-img{
   width: 50%;
   margin: 20px 25%;
   margin-bottom: 20px;
}
.news-box-img img{
   width:100%;
}
.news-box-two{
 
  float: left;
  width: 100%;
  font-size: 18px;
  color: #666;
  margin-bottom: 20px;
   text-align: center;
}


.news-box-img-two{
   width: 60%;
   margin: 20px 20%;
   margin-bottom: 20px;
}
.news-box-img-two img{
   width:100%;
}
.hardware-main{
  width: 100%;
}
.hardware-li{
  padding: 10px;
  box-sizing: border-box;
}
.hardware-title{
  width: 100%;
  background: #f6f6f6;
  padding: 10px 20px;
   box-sizing: border-box;
  color: #4a4a4a;
  font-weight: 800;
}

.serviceprovider-main-three{
 float: left;
  width: 100%;
  padding: 30px 0;
  background: #f6f6f6;
}
.serviceprovider-main-box-three{
  width: 1200px;
 margin: 0  auto;
}

@media (max-width: 1200px) {
  .title-home-main {
    padding: 30px 0;
  }
  
  .title-home-one {
    font-size: 24px;
  }
   .footer-main{
    zoom: 0.8;
  }
  .serviceprovider-main-three{
 float: left;
  width: 100%;
  padding:0;
  background: #f6f6f6;
}
   .serviceprovider-main-two {
    float: left;
    width: 80%;
    margin: 0 10%;
    zoom: 0.5;
  }
  .serviceprovider-main-box-three{
  float: left;
  width: 100%;
  zoom: 0.6;
  padding: 0 20px;
  box-sizing: border-box;
}
  .solution-main{
  padding: 0px 0px;
}
.solution-title-one{
  font-size: 16px;
  color: #666;
}

.solution-box{
 float: left;
 width: 100%;
  }
  .solution-box-two{
    flex-direction: column;
  }
  .title-bottom{
    padding:30px 10px;
  }
  .solution-box-two{
     float: left;
 width: 100%;
  }
  .solution-box-three{
  width: 98%;
  margin: 10px 1%;
}
 .solution-box-four {
    flex-direction: column;
    width: 100%;
  }

  .item-one  {
    flex: 1 1 100%; /* 在手机端一行显示1个项目 */
    margin-bottom: 20px;
  }
  .img-li-two{
   max-width: 100%;
  height: auto;
}

.news-box-img{
   width: 100%;
   margin: 20px 0;
}

.news-box-img-two{
   width: 100%;
   margin: 20px 0;
}
}
</style>
